import * as styles from './styles';
import * as React from 'react';
import {style} from 'typestyle';

const hrClass = style({
  backgroundColor: styles.colors.warmGrey3,
  width: '100%',
  height: '1px',
  border: 'none',
  margin: '0px'
});

export const Hr = ({}) => {
  return (
    <hr className={hrClass}/>
  );
}
